export default "__VITE_ASSET__goowluTq__"